export const ROLES_LIST_REQUEST = "ROLES_LIST_REQUEST";
export const ROLES_LIST_RESPONSE = "ROLES_LIST_RESPONSE";

export const GET_MODULES_PERMISSIONS_REQUEST =
  "GET_MODULES_PERMISSIONS_REQUEST";
export const GET_MODULES_PERMISSIONS_RESPONSE =
  "GET_MODULES_PERMISSIONS_RESPONSE";

export const ADD_ROLE_REQUEST = "ADD_ROLE_REQUEST";

export const GET_EDIT_ROLE_DATA_REQUEST =
  "GET_EDIT_ROLE_DATA_REQUEST";
export const GET_EDIT_ROLE_DATA_RESPONSE =
  "GET_EDIT_ROLE_DATA_RESPONSE";

export const EDIT_ROLE_REQUEST = "EDIT_ROLE_REQUEST";

export const ROLE_DETAILS_REQUEST = "ROLE_DETAILS_REQUEST";
export const ROLE_DETAILS_RESPONSE = "ROLE_DETAILS_RESPONSE";

export const DELETE_ROLE_REQUEST = "DELETE_ROLE_REQUEST";
